var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m14 3 9 9-9 9h-1v-4.999q-.773-.002-1.5.047c-2.664.184-4.978.977-7.99 3.513q-.252.21-.51.439H2a12 12 0 0 1 .096-1.5C2.789 13.123 7.193 9.18 13 8.027V3zm.5 6.259-1.208.24c-4.811.955-8.36 3.923-9.445 7.888 1.296-.947 2.524-1.614 3.763-2.065 1.813-.66 3.55-.821 5.39-.821h1.5v3.878L20.879 12 14.5 5.621z"
})));
export default SvgShare;